import React, { useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import bandPhoto from '../../images/photos/kirke-band-photo-001.webp';
import { useIsMobile } from '../../utils/useIsMobile';

const useStyles = makeStyles()((theme) => ({
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  image: {
    width: '1024px',
    height: 'auto',
  },
  imageMobile: {
    width: '100%',
    height: 'auto',
  },
}));

const BandComponent: React.FC = () => {
  const { classes } = useStyles();
  const isMobile = useIsMobile();
  const [text, setText] = useState<string>('');

  useEffect(() => {
    fetch('/publicContentUtils/band-introduction.txt')
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.text();
      })
      .then((text) => setText(text))
      .catch((err) => {
        console.error(err);
        setText('Failed to load file');
      });
  }, []);

  return (
    <>
      {isMobile ? (
        <>
          <div className='title title-mobile content-wrapper'>KIRKE</div>
          <div className={`text-body text-body-mobile content-wrapper`}>
            {text}
          </div>
        </>
      ) : (
        <>
          <div className='title title-desktop content-wrapper'>KIRKE</div>
          <div className={`text-body text-body-desktop content-wrapper`}>
            {text}
          </div>
        </>
      )}
      <div className={classes.imageContainer}>
        <img
          src={bandPhoto}
          alt='kirke-band-photo'
          title='kirke-band-photo'
          className={isMobile ? classes.imageMobile : classes.image}
          loading='lazy'
        />
      </div>
    </>
  );
};

export default BandComponent;
